module.exports = __webpack_public_path__ + "static/media/nuova-2-comp.6d5817ed.jpg";